var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "800",
      "height": "800",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 17v-6",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "1",
      "cy": "1",
      "r": "1",
      "transform": "matrix(1 0 0 -1 11 9)",
      "fill": "currentColor"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }